var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("rect", {
    id: "Iconly/Curved/Light/2 User",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "currentColor",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M2.74 18.67C2.74 16.45 5.86 14.44 9.55 14.44C13.23 14.44 16.36 16.43 16.36 18.65C16.36 20.88 13.25 21.45 9.55 21.45C5.88 21.45 2.74 20.9 2.74 18.67Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M13.92 6.91C13.92 4.5 11.96 2.55 9.55 2.55C7.14 2.55 5.19 4.5 5.19 6.91C5.18 9.31 7.12 11.27 9.52 11.27L9.55 11.27C11.96 11.27 13.92 9.32 13.92 6.91Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M16.8 10.08C18.2 9.7 19.23 8.42 19.23 6.9C19.23 5.31 18.11 3.99 16.61 3.68",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M17.46 13.65C19.44 13.65 21.14 15 21.14 16.2C21.14 16.91 20.56 17.64 19.67 17.84",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIcon);
export default __webpack_public_path__ + "static/media/leadsIcon.26808bfb17480eadb1c635658323a53f.svg";
export { ForwardRef as ReactComponent };